import { variables } from '@indriver/yrel';
import styled from 'styled-components';

export const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  color: ${variables['text-and-icon-primary']};
`;
